export default __webpack_public_path__ + "static/media/mgt.6fe45ca6.svg";